import i18n from "@/core/plugins/i18n";
import {
  IRecommendationRange,
  RecommendationParamEnum,
} from "../models/recommendation.model";

export const VALIDATION_RULES = {
  required: (value: any) => {
    if (value === undefined || value === null) return i18n.t("required");
    return true;
  },
  range: (value: number, min?: number, max?: number) => {
    if ((min && value < min) || (max && value > max)) {
      return i18n.t("rangeError", { min, max });
    }
    return true;
  },
};

export const EMPTY_STRING = "--";

export const RECOMMENDATION_RANGES: Record<
  keyof typeof RecommendationParamEnum,
  IRecommendationRange
> = {
  carbon: {
    min: 1,
    max: 3.5,
  },
  metallization: {
    min: 88,
    max: 95,
  },
  productionRate: {
    min: 70,
    max: 130,
  },
};

export const RECOMMENDATION_UNIT: Record<
  keyof typeof RecommendationParamEnum,
  string
> = {
  carbon: "%",
  metallization: "%",
  productionRate: "t/h",
};
